import React from 'react';

export default () => (
    <time dateTime="2020-09-01">Effective as of September 01, 2020</time>
);